import LoginBg from '../Assets/Images/banner-1.jpg'
import MCLogo from '../Assets/Images/MCLogo.png'
import folderNewIcon from '../Assets/Images/icons-folder-New.svg'
import ApproveIcon from '../Assets/Images/icons-approved.svg'
import iconsexportdata from '../Assets/Images/icons-export-data.svg'
import folderIcon from '../Assets/Images/icons-folder.svg'
import addnewfolder from '../Assets/Images/addnewfolder.svg'
import mobileMenu from '../Assets/Images/mobileMenu.svg'
import infoIcon from '../Assets/Images/icons-info.svg'
import closeIcon from '../Assets/Images/icons-close.svg'
import checkIcon from '../Assets/Images/icons-checkmark.png'
import uncheckIcon from '../Assets/Images/icons-uncheck.png'
import noOrganization from '../Assets/Images/no-organization.svg'
import upArrowIcon from '../Assets/Images/icons-uparrow.svg'
import downArrowIcon from '../Assets/Images/icons-downarrow.svg'
import emailSent from '../Assets/Images/mail-sent.svg'
import emailFailed from '../Assets/Images/mail-failed.svg'
import currentPlan from '../Assets/Images/current-plan.svg'
import previousPlan from '../Assets/Images/previous-plan.svg'
import infoSub from '../Assets/Images/info-sub.svg'
import infodelete from '../Assets/Images/info-delete.svg'
import addUser from '../Assets/Images/add-user.png'
import loginIphone from '../Assets/Images/iPhone.png'
import googlePlay from '../Assets/Images/google-play.png'
import appleIcon from '../Assets/Images/appleicon.png'
import logomediacentric from '../Assets/Images/logo-mediacentric.png'
import closeicon from '../Assets/Images/close-icon.png'
import iconsAdd from '../Assets/Images/icons-add.png'
import deleteIcon from '../Assets/Images/icons-delete.png'
import editIcon from '../Assets/Images/icons-edit.png'
import sequenceIcon from '../Assets/Images/icons-sequence.svg'
import banner from '../Assets/Images/banner-2.jpg'
import exportAllReady from '../Assets/Images/exportAllReady.svg'
import exportAllExpire from '../Assets/Images/exportAllExpire.svg'
import desktop from '../Assets/Images/desktop.png'
import appStore from '../Assets/Images/appStore.png'
import playStore from '../Assets/Images/playStore.png'
import successImage from '../Assets/Images/successImage.png'
import image404 from '../Assets/Images/image404.svg'

export const images = {
  LoginBg,
  MCLogo,
  folderNewIcon,
  ApproveIcon,
  iconsexportdata,
  folderIcon,
  addnewfolder,
  mobileMenu,
  infoIcon,
  closeIcon,
  checkIcon,
  uncheckIcon,
  noOrganization,
  upArrowIcon,
  downArrowIcon,
  emailSent,
  emailFailed,
  currentPlan,
  previousPlan,
  infoSub,
  infodelete,
  addUser,
  loginIphone,
  googlePlay,
  appleIcon,
  logomediacentric,
  closeicon,
  iconsAdd,
  deleteIcon,
  editIcon,
  sequenceIcon,
  banner,
  exportAllExpire,
  exportAllReady,
  EmptyImage: 'https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg',
  desktop,
  playStore,
  appStore,
  successImage,
  image404,
}
